import styled from "styled-components";

export const ContentContainer = styled.div`
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  padding: 32px;
`;

export const FormSection = styled.div`
  margin-bottom: 32px;
  padding-bottom: 32px;
  border-bottom: 1px solid #e5e7eb;

  &:last-child {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
  }
`;

export const SectionTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 24px;
`;

export const InputGroup = styled.div`
  margin-bottom: 20px;
`;

export const Label = styled.label`
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  margin-bottom: 8px;

  .required {
    color: #ef4444;
    margin-left: 4px;
  }
`;

export const FieldHint = styled.div`
  font-size: 12px;
  color: #6b7280;
  margin-top: 6px;
`;

export const PositionCounter = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  background: #f9fafb;
  border-radius: 8px;
  margin-top: 16px;
`;

export const CounterLabel = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: #6b7280;
`;

export const CounterValue = styled.span`
  font-size: 18px;
  font-weight: 700;
  color: ${props => {
    if (props.isOverLimit) return "#ef4444";
    if (props.isComplete) return "#10b981";
    return "#3b82f6";
  }};
`;

export const ValidationMessage = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 12px 16px;
  border-radius: 8px;
  margin-top: 12px;
  font-size: 14px;
  line-height: 1.5;
  
  ${props => props.type === "error" && `
    background: #fef2f2;
    border: 1px solid #fecaca;
    color: #991b1b;
  `}
  
  ${props => props.type === "warning" && `
    background: #fffbeb;
    border: 1px solid #fde68a;
    color: #92400e;
  `}
  
  svg {
    flex-shrink: 0;
    margin-top: 2px;
  }
`;

export const RangesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const AddRangeButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 24px;
  background: #ffffff;
  border: 2px dashed #d1d5db;
  border-radius: 8px;
  color: #6b7280;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  width: 100%;
  margin-top: 8px;

  &:hover:not(:disabled) {
    border-color: #3b82f6;
    color: #3b82f6;
    background: #eff6ff;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
